import { render, staticRenderFns } from "./cabinet-requests-list-secondary.vue?vue&type=template&id=10a87633&scoped=true"
import script from "./cabinet-requests-list-secondary.vue?vue&type=script&lang=js"
export * from "./cabinet-requests-list-secondary.vue?vue&type=script&lang=js"
import style0 from "./cabinet-requests-list-secondary.vue?vue&type=style&index=0&id=10a87633&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a87633",
  null
  
)

export default component.exports